import type React from 'react'
import styled from 'styled-components'

interface Props {
  name: string
  icon?: string
}

const Container = styled.div``

const EntityPanelHeader: React.FC<Props> = ({ name, icon }) => {
  return (
    <Container>
      <div className="side-by-side-flex-start">
        <img
          src={`/assets/svg/${icon || name}.svg`}
          alt=""
          style={{
            marginRight: 5,
            maxWidth: 45,
          }}
        />{' '}
        <h4>{name}</h4>
      </div>
    </Container>
  )
}

export default EntityPanelHeader
